
function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; Secure; SameSite=None';
}

const processLinks = (text) => {
    const urlRegex = /\[\[URL\]\](.*?)\[\[\/URL\]\]/g;
    return text.replace(urlRegex, (match, url) => {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">Click here for more information</a>`;
    });
  };

  const addGetQuotes = (output) => {
    // Replace [QUOTE_BUTTON] with a custom element
    const modifiedOutput = output.replace("[QUOTE_BUTTON]", '<span class="quote-button-placeholder"></span>');
    return modifiedOutput;
};



export {setCookie , processLinks , addGetQuotes}